<template>
	<div class="wrap">
		<div class="main">
			<div class="neibox">
				<div class="zhititle">
					在线充值
				</div>
				<div class="chongbox">
					<div class="chongtitle">
						余额
					</div>
					<div class="yubut">
						{{money}}
					</div>
				</div>
				<div class="chongbox">
					<div class="chongtitle">
						充值余额
					</div>
					<el-input style="width: 230px;"
					  placeholder="请输入金额"
					  v-model="input"
					  clearable>
					</el-input>
				</div>
				<div class="chongbox">
					<div class="chongtitle">
						充值方式
					</div>
					 <el-radio v-model="radio"  label="1">支付宝</el-radio>
				</div>
				<div class="chongbox">
					<div class="chongtitle">
						
					</div>
					 <el-button type="primary" @click="getAliPay">确认</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				input:'',
				radio: '1',
				money:''
			}
		},
		created() {
			this.getUserMoney()
		},
		methods: {
			async getUserMoney(){
				const res = await this.$api.getUserMoney();
				this.money = res.data
			},
			async getAliPay() {
				const res = await this.$api.getAliPay({
					total_amount:this.input,
				});
				if(res.code == 1){
					document.write(res.data)
				
				}else{
					alert('金额错误')
				}
			},
		},

	}
</script>

<style>
	.neibox {
		padding: 20px;
		background-color: #ffffff;
		border-radius: 5px;
	}
	.zhititle{
		font-size: 15px;
		color: #333333;
		border-bottom: 1px solid #dddddd;
		padding-bottom: 15px;
		margin-bottom: 15px;
	}
	.chongbox{
		display: flex;
		align-items: center;
		padding-bottom: 25px;
	}
	.chongtitle{
		font-size: 14px;
		color: #333333;
		width: 100px;
		text-align: right;
		flex-shrink: 0;
		margin-right: 15px;
	}
	.yubut{
		width: 208px;
		height: 40px;
		border-radius: 5px;
		padding: 0 10px;
		line-height: 40px;
		font-size: 14px;
		color: #333333;
		border: 1px solid #dedede;
	}
</style>